import { downloadAccess, } from '../types'

const initState = {
  data: null,
  error: null,
  loading: false,
}

export default function getDownloadAccessReducer (state = initState, action) {
  switch (action.type) {
    
    case downloadAccess.GET_DOWNLOAD_ACCESS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        data: null
      }
    
    case downloadAccess.GET_DOWNLOAD_ACCESS_PENDING:
      return {
        ...state,
        loading: true,
      }
    
    case downloadAccess.GET_DOWNLOAD_ACCESS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }

    default:
      return state
  }
}
